import script from "./default-layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./default-layout.vue?vue&type=script&lang=ts&setup=true"

import "./default-layout.vue?vue&type=style&index=0&id=9da31b88&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9da31b88"]])

export default __exports__